/** global: requestAnimationFrame */
/** global: setTimeout */
let tasks = [], DONE = -1;
let raf = typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : typeof setTimeout !== "undefined" ? fn => setTimeout(fn, 16) : function () {};
raf(function _raf(time) {
	raf(_raf);
	if (tasks.length === 0) {
		return false;
	}
	let i = 0;
	while (i < tasks.length) {
		if (tasks[i](time) === DONE) {
			tasks.splice(i, 1);
		} else {
			i++
		}
	}
	return true;
});
export { tasks, DONE };